import _Promise from 'babel-runtime/core-js/promise';
// 高德地图 - 异步
export default function weather() {
  var ak = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '4e2daea1e35427e038df17773953c2a2';

  return new _Promise(function (resolve, reject) {
    window.onload = function () {
      resolve(AMap);
    };
    if (typeof AMap === 'undefined') {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://webapi.amap.com/maps?v=1.4.13&key=" + ak + "&plugin=AMap.CitySearch";
      script.onerror = reject;
      document.head.appendChild(script);
    } else {
      resolve(AMap);
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/weather.js
// module id = null
// module chunks = 